import React from "react";
import { ChannelContext } from "../contexts";
import "../assets/styles/footer.sass";
import Utility from "../Utility";
import Socials from "./Socials";
import FooterLinks from "./FooterLinks";
import { Link } from "react-router-dom";
const Footer = ({ content }) => {
  return (
    <ChannelContext.Consumer>
      {(currentChannel) => (
        <div className="ur-mini-bg-black">
          <div className="ur-mini-footer ur-mini-container">
            <FooterLinks content={content} />
            <Link
              to={Utility.getChannelUrl(content, currentChannel)}
              className="ur-mini-logo"
            >
              <div
                style={{
                  backgroundImage: `url(${Utility.getChannelFooterLogo(
                    content,
                    currentChannel
                  )})`,
                }}
              ></div>
            </Link>
            <div>
              <Socials content={content} />
            </div>
          </div>
        </div>
      )}
    </ChannelContext.Consumer>
  );
};
export default Footer;
